import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { timeout } from 'rxjs';
import { API_BASE_URL } from '../../../shared/config/api.config';

export interface UploadTicketVoucherRequest {
  paymentReference: string;
  userId?: number;
  bankAccountId: number;
  operationNumber: string;
  operationType: string;
  reportedAmount: number;
  currencyCode: string;
  note: string;
  file: File;
}

@Injectable({ providedIn: 'root' })
export class TicketPaymentService {
  private readonly http = inject(HttpClient);

  uploadVoucher(request: UploadTicketVoucherRequest) {
    const form = new FormData();
    form.append('bankAccountId', String(request.bankAccountId));
    form.append('operationNumber', request.operationNumber);
    form.append('operationType', request.operationType);
    form.append('reportedAmount', request.reportedAmount.toFixed(2));
    form.append('currencyCode', request.currencyCode);
    form.append('note', request.note);
    form.append('file', request.file, request.file.name);

    let headers = new HttpHeaders({ 'X-Correlation-ID': `ticket-voucher-${crypto.randomUUID()}` });
    if (request.userId != null) headers = headers.set('X-User-Id', String(request.userId));

    return this.http.post(
      `${API_BASE_URL}/ticket-payments/intents/${encodeURIComponent(request.paymentReference)}/vouchers`,
      form,
      { headers },
    ).pipe(timeout(30000));
  }
}
